/* Email → Provider tab: "How to get these credentials" for the selected provider — the catalogue's bilingual steps and official links for the selected provider. */
import { useI18n } from "../../../i18n";
import SetupGuide, { GuideSteps, LinkList } from "../components/SetupGuide";
import { providerById } from "./catalog";

export default function ProviderGuide({ provider, open, onDns }: { provider: string; open: boolean; onDns?: () => void }) {
  const { L } = useI18n();
  const p = providerById(provider);
  if (!p) return null;
  return (
    <SetupGuide key={p.id} testId="email-guide" open={open} title={L("How to get these credentials", "كيف تحصل على بيانات الاعتماد")}
      sub={L(p.name + " — where each value comes from, step by step", p.nameAr + " — من أين تحصل على كل قيمة، خطوة بخطوة")}>
      <div data-provider={p.id} data-testid={"email-guide-" + p.id}>
        <GuideSteps steps={p.setup.steps.map(([en, ar]) => <p key={en} style={{ margin: 0 }}>{L(en, ar)}</p>)} testPrefix="email-guide" />
      </div>
      <div>
        <h4 className="sm" style={{ margin: "0 0 6px" }}>{L("Official links", "روابط رسمية")}</h4>
        <LinkList links={p.setup.links} testPrefix="email-guide" />
      </div>
      {p.kind !== "log" && onDns && (
        <p className="xs muted" style={{ margin: 0 }}>
          {L("The exact SPF, DKIM and DMARC records for your domain are on the ", "سجلات SPF وDKIM وDMARC الدقيقة لنطاقك موجودة في تبويب ")}
          <button type="button" className="linkish" onClick={onDns} data-testid="email-guide-dns">{L("Deliverability tab", "التسليم")}</button>.
        </p>
      )}
    </SetupGuide>
  );
}
